<template>
    <v-dialog v-model="show" persistent no-click-animation width="450">
        <v-card class="NoticeDeleteNode">
            <div class="display-flex align-start">
                <img src="/img/scenario/error.png" alt="icon-error" class="icon-error mr-12">
                <div style="margin-top: 3px">
                    <div class="message">{{ message }}</div>
                    <ul>
                        <li class="item-error" v-for="(item, index) in listError" :key="index">
                            <div style="font-family: 'open sans bold'">{{ item }}</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="display-flex justify-end mt-12">
                <div class="btn-custom" @click="close">OK</div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";

export default {
    name: "NoticeDeleteNode",
    mixins: [DialogPromiseMixin],
    data() {
        return {
            message: '',
            listError: []
        }
    },
    methods: {
        open(message, listError) {
            this.message = message ? message : ''
            this.listError = listError ? listError : []
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        }
    }
}
</script>

<style scoped lang="scss">
.NoticeDeleteNode {
    border-radius: 5px !important;
    padding: 12px;
}

.icon-error {
    width: 70px;
}

.message {
    font-family: "open sans";
    font-size: 14px;
}

.item-error {
    font-family: "open sans";
    font-size: 14px;
}
</style>
